// components/HydrationState.tsx — "still loading" / "couldn't load" for the datasets the
// shell hydrates once per sign-in (notifications, conversations, bookmarks).
//
// Their pages render from a store, and an empty store used to mean two different things:
// "you have none" and "it has not arrived" (or "it failed"). This puts a skeleton or a
// Retry in the list's place until the first load has actually succeeded.
import { LoadState } from '@/ui/LoadState';
import { useHydrationStore, type HydratedResource } from '@/core/stores/hydrationStore';
import { hydrateResource } from '@/hooks/useGlobalHydration';

export function HydrationState({
  resource,
  label,
  cards = 3,
}: {
  resource: HydratedResource;
  /** Completes "Couldn't load …" and names the skeleton for assistive tech. */
  label: string;
  cards?: number;
}) {
  const status = useHydrationStore((s) => s.status[resource]);
  if (status === 'ready') return null;
  return (
    <LoadState
      loading={status !== 'error'}
      error={status === 'error'}
      retry={() => void hydrateResource(resource)}
      label={label}
      cards={cards}
    />
  );
}
